
<div class="slab-hierarchy" :data-overflow="overflow">
	<div
		class="slab-container"
		:size="size"
		:type="type"
		:state="state"
		:stateType="stateType"
		:disabled="disabled"
		:selected="selected"
		:alignItems="alignItems"
		:effects="effects"
		:noPadding="noPadding"
		:borderType="borderType"
		:data-qa-field="dataQaField"
		@click="handleClick"
	>
		<div class="slab-content">
			<div v-if="$slots['primary-action']" class="slab-primary-action">
				<!-- @slot Used to display primary icon on left side of slab-->
				<slot name="primary-action" />
			</div>
			<div class="slab-title">
				<span class="slab-title-wrapper">
					<!-- @slot Used to display title of slab-->
					<slot />
				</span>
			</div>
		</div>
		<div v-if="$slots['secondary-actions']" class="slab-secondary-actions">
			<!-- @slot Used to display secondary icons on right side of slab-->
			<slot name="secondary-actions" />
		</div>
	</div>
	<div v-if="$slots['child-slabs']" class="child-slabs" :type="type" :size="size">
		<slot name="child-slabs" />
	</div>
</div>
